import { useEffect, useState } from "react";
// for work_images
import work1 from "../assets/images/work_images/1.jpg";
import work2 from "../assets/images/work_images/2.jpg";
import work3 from "../assets/images/work_images/3.jpg";
import work4 from "../assets/images/work_images/4.jpg";
import work5 from "../assets/images/work_images/5.jpg";
import work6 from "../assets/images/work_images/6.jpg";
import work7 from "../assets/images/work_images/7.jpg";
import work8 from "../assets/images/work_images/8.jpg";
import work9 from "../assets/images/work_images/9.jpg";
// works small images
import workSmall1 from "../assets/images/work_images/small/1.jpg";
import workSmall2 from "../assets/images/work_images/small/2.jpg";
import workSmall3 from "../assets/images/work_images/small/3.jpg";
import workSmall4 from "../assets/images/work_images/small/4.jpg";
import workSmall5 from "../assets/images/work_images/small/5.jpg";
import workSmall6 from "../assets/images/work_images/small/6.jpg";
import workSmall7 from "../assets/images/work_images/small/7.jpg";
import workSmall8 from "../assets/images/work_images/small/8.jpg";
import workSmall9 from "../assets/images/work_images/small/9.jpg";
// blog post images
import blog6 from "../assets/images/blog_images/6.jpg";
import blog4 from "../assets/images/blog_images/blog4.png";
import blog2 from "../assets/images/blog_images/blog2.png";
import blog1 from "../assets/images/blog_images/1.jpg";
import blog3 from "../assets/images/blog_images/blog3.png";
import blog5 from "../assets/images/blog_images/5.jpg";
// blog image small
import blogSmall6 from "../assets/images/blog_images/small/6.jpg";
import blogSmall4 from "../assets/images/blog_images/blog4.png";
import blogSmall2 from "../assets/images/blog_images/blog2.png";
import blogSmall1 from "../assets/images/blog_images/1.jpg";
import blogSmall3 from "../assets/images/blog_images/blog3.png";
import blogSmall5 from "../assets/images/blog_images/small/5.jpg";

import img1 from "../assets/images/slider/brand-1.png";
import img2 from "../assets/images/slider/brand-2.png";
import img3 from "../assets/images/slider/brand-3.png";
import img4 from "../assets/images/slider/brand-4.png";
import img5 from "../assets/images/slider/brand-5.png";
import img6 from "../assets/images/slider/brand-6.png";
import img7 from "../assets/images/slider/brand-7.png";
import img8 from "../assets/images/slider/brand-8.png";
import img9 from "../assets/images/slider/brand-9.png";
import img10 from "../assets/images/slider/brand-10.png";
import img11 from "../assets/images/slider/brand-11.png";
import img12 from "../assets/images/slider/brand-12.png";
//  icon use as img here
import icon from "../assets/images/icons/icon-1.svg";
import icon1 from "../assets/images/icons/icon-2.svg";
import icon2 from "../assets/images/icons/icon-3.svg";
import icon3 from "../assets/images/icons/icon-4.svg";
import icon4 from "../assets/images/icons/icon-5.svg";
import icon5 from "../assets/images/icons/icon-6.svg";
// contact image
import iconPhone from "../assets/images/contact/phone-call 1.png";
import iconEmail from "../assets/images/contact/email 1.png";
import iconMap from "../assets/images/contact/map 1.png";
import { CgNotes } from "react-icons/cg";
import { FaBlogger, FaRegUser, FaAward } from "react-icons/fa";
import { AiOutlineHome } from "react-icons/ai";
import { FiCodesandbox } from "react-icons/fi";
import { RiContactsBookLine } from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";

import { MdOutlineBusinessCenter, MdOutlineSchool } from "react-icons/md";

const AllData = () => {
  const [check, setCheck] = useState(false);
  const [local, setLocal] = useState(localStorage.getItem("theme"));
  const [singleData, setSingleData] = useState({});
  const [isOpen, setIsOpen] = useState(false);

  // dark and light theme controls
  useEffect(() => {
    const themeValue = localStorage?.getItem("theme");

    if (!themeValue) {
      setCheck(false);
      localStorage.setItem("theme", "light");
    } else {
      themeValue === "dark" && setCheck(true);
      themeValue === "light" && setCheck(false);
    }

    localStorage?.getItem("theme") === "dark"
      ? document.documentElement.classList.add("dark")
      : document.documentElement.classList.remove("dark");
  }, []);

  // Create and light theme function
  const handleTheme = (value) => {
    if (value === "light") {
      setCheck(false);
      localStorage.setItem("theme", "light");
      setLocal("light");
    } else {
      setCheck(true);
      localStorage.setItem("theme", "dark");
      setLocal("dark");
    }
    localStorage?.getItem("theme") === "dark"
      ? document.documentElement.classList.add("dark")
      : document.documentElement.classList.remove("dark");
  };

  // fillter portfilo data
  const handleData = (text) => {
    if (text === "All") {
      setData(workItems);
    } else {
      const findData = workItems.filter((item) => item.tag === text);
      setData(findData);
    }
  };

  // find items for portfilo  modal open
  const handleModelData = (id) => {
    const find = workItems.find((item) => item?.id === id);
    setSingleData(find);
    setIsOpen(true);
  };

  // find items for Blogs  modal open
  const handleBlogsData = (id) => {
    const find = blogsData.find((item) => item?.id === id);
    setSingleData(find);
    setIsOpen(true);
  };

  // Active navlinks function
  function NavLink({
    to,
    className,
    activeClassName,
    inactiveClassName,
    ...rest
  }) {
    let location = useLocation();
    let isActive = location.pathname === to;
    let allClassNames =
      className + (isActive ? `${activeClassName}` : `${inactiveClassName}`);
    return <Link className={allClassNames} to={to} {...rest} />;
  }

  // Elements for protfilo section
  const workItems = [
    {
      id: "1",
      tag: "Contributed",
      title: "Curate",
      img: work1,
      imgSmall: workSmall1,
      bg: "#FFF0F0",
      github: "https://github.com/kitanablade/curarte.git",
      gtext: "Github Repository Link",
      langages: "HTML,CSS,jQuery",
      link: "https://kitanablade.github.io/curarte/",
      linkText: "Visit Curarte",
      description:
        "curARTe is an application to research and store artworks from the Art Institute of Chicago's collection to display on a personal gallery wall. The artwork and quick research content will be stored in local storage to continue displaying after the page is closed.This application makes use of two server-side APIs - namely, the Art Institute of Chicago and mediawiki. Both APIs were used to initialize more general searches to supplement targeted queries to generate search responses. For example, the Art Institute of Chicago's API does not return images but can return enough information to generate an image upon query. A similar case is true of mediawiki which required search variables to be passed through to target smaller sections of text from the wiki page to be useful in the application. For both cases, our development team identified the necessary variables to pass through and concatenate into usable search parameters for a secondary query or to generate the desired content on the page.",
    },
    {
      id: "2",
      tag: "Contributed",
      title: "Sarapp",
      img: work2,
      imgSmall: workSmall2,
      bg: "#FFF3FC",
      github: "https://github.com/anniech1/sarApp",
      gtext: "Github Repository Link",
      langages: "Node, Express",
      link: "",
      linkText: "Visit Sarapp",
      description:
        "Our project was inspired by the lack of representation in mainstream media and society of foods from different parts of the world. We wanted to create a project that would shine a light on cultures from around the world and show their delicious cuisines. We want to introduce users to a new palate consisting of new cultures, ingredients, and methods of cooking and eating. Food is what brings people together and what better way to merge tech and food than creating a community of food-lovers from around the world that can share the foods and recipes that they love in a fun and interactive way! Our project-sarApp-is a recipe sharing app for food lovers of the world! So we created a Recipe sharing blog that allows users to add their own recipes once they are logged in to the application.Improved the user experience by adding the profile section for users' posts. Following technologies were used for this project : Node, Express, API, Bootstrap, Font Awesome, Sequalize ORM with MySQL2, handlebars",
    },
    {
      id: "3",
      tag: "Contributed",
      title: "Peas By Spring",
      img: work3,
      imgSmall: workSmall3,
      bg: "#FFF0F0",
      github: "https://github.com/Axeljk/garden-app-frontend",
      gtext: "Github Repository Link",
      langages: "React, MongoDB",
      link: "",
      linkText: "Visit Peas By spring",
      description:
        "This application is a tool to plan out your garden using recommended or custom garden layouts, search functionality for plant specimens, and a plant library to import plants into your garden utilizing drag and drop features. Following technologies are used for this project : React, Node ,Express, MongoDB, MaterialUI",
    },
    { 
      id: "4",
      tag: "Personal",
      title: "JATE",
      img: work4,
      imgSmall: workSmall4,
      bg: "#E9FAFF",
      github: "https://github.com/Akshu3011/text-editor.git",
      gtext: "Github Repository Link",
      langages: "HTML, CSS, Javascript",
      link: "",
      linkText: "Visit JATE",
      description:
        "This app is a single-page application that meets the PWA criteria. Additionally, it also feature a number of data persistence techniques that serve as redundancy in case one of the options is not supported by the browser. The application also functions offline. Following technologies are used for this project : HTML, CSS, Javascript",
    },
    {
      id: "5",
      tag: "Personal",
      title: "NoteTaker",
      img: work5,
      imgSmall: workSmall5,
      bg: "#FFFAE9",
      Github: "https://github.com/Akshu3011/NoteTaker.git",
      gtext: "Github Repository Link",
      langages: "HTML, CSS, Javascript",
      link: "",
      linkText: "Visit NoteTaker",
      description:
        " This application will help the user to create and save notes for the busy schedule. This application uses an Express.js back end and will save and retrieve note data from a JSON file. Following technologies are used for this project : HTML, CSS, Javascript",
    },
    {
      id: "6",
      tag: "Personal",
      title: "Weather Dashboard",
      img: work6,
      imgSmall: workSmall6,
      bg: "#F4F4FF",
      github: "https://github.com/Akshu3011/WeatherDashboard.git",
      gtext: "Github Repository Link",
      langages: "HTML, CSS, Javascript",
      link: "https://akshu3011.github.io/WeatherDashboard/",
      linkText: "Visit Weather Dashboard",
      description:
        "This application will help the trvellers to see the weather outlook for multiple cities so that they can plan a trip accordingly. This application uses the OpenWeather One Call API to retrieve weather data for cities. The persistent data (recent searches) are stored in localstorage. Following technologies are used for this project : HTML, CSS, Javascript",
    },
   
   
  ];
  const [data, setData] = useState(workItems);

  // Elements for Blogs section
  const blogsData = [
    {
      id: "1",
      img: blog1,
      imgSmall: blogSmall1,
      date: "August 22",
      category: "Web Development",
      title: "Matching a URL Regex.",
      bg: "#FCF4FF",
      description:
        "Regex or Regular expressions are patterns used to match character combinations in strings. In this tutorial we'll see how to use a regex to match a URL. \n URL regular expressions can be used to verify if a string has a valid URL format.\nvar urlRegex= ^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$ \nWe'll walk-through each of the components to determine how they work and why we're using them.\n        Anchors: Anchors belong to the family of regex tokens that don't match any characters, but that assert something about the string or the matching process. Anchors assert that the engine's current position in the string matches a well-determined location: for instance, in our section of code: \n        The two principal anchors in this regex expression are the ^ at the beginning and the $ at the end which constitute an exact string match with the components included within the two anchors.When used alone, the ^ anchor matches any string that begins with the characters that follow the anchor. The $ matches any string that ends with the characters that precede it. By enclosing the regex between these two anchors, we are asking the search function to match exactly is included between them (what it begins AND ends with). \n Quantifiers : Quantifiers match a number of instances of a character, group, or character class in a string.\n        + Matches a string that has the specified characters on the left side followed by one or more items on the right side.\n        The  quantifier matches the preceding element zero or more times. It's equivalent to the {0,} quantifier.  is a greedy quantifier whose lazy equivalent is ?. \n       The ? quantifier matches the preceding element zero or one time. It's equivalent to {0,1}. ? is a greedy quantifier whose lazy equivalent is ??.\n {} Sets either an exact amount, min and max, or more than one copies of the sequence before the quantifiers.\n e.g. in our section of code:\n        ([a-z\.]{2,6}) matches the previous token ([a-z\.]) between 2 and 6 times, as many times as possible.\n Grouping Constructs: Grouping constructs delineate the subexpressions of a regular expression and capture the substrings of an input string.\n        e.g. in our section of code:\n(https?:\/\/)? contains two ? quantifiers. This expression is looking for an http:// OR an https://. For this reason a single internal s is optional. The same is true for the entire expression included in the parenthesis, for which reason it is followed by a ?. In other words, a valid URL may begin with http:// OR https://, or it may not begin with either of them at all (the input begins with www.). The same applies for the / at the very end of the expression.\n([a-z]+) => [\w\.] Matches any word character equivalent to \w = [a-zA-Z0-9_] or \. matches the character.one or more times.\n        Bracket Expressions: Bracket expressions can be used to match a single character or collating element. Brackets indicate a set of characters to match. Any individual character between the brackets will match, and you can also use a hyphen to define a set. e.g. in our section of code: \n  [a-z\.] Here the - defines a set of character from [a-z]  \nCharacter Classes: Character classes distinguish kinds of characters such as, for example, distinguishing between letters and digits.        e.g. in our section of code:\n        [\da-z\.-]  Here  \dMatches a single digit (Equivalent to [0-9]) \n        \w character class that looks for any alphanumeric character.  \nThe OR Operator: The main OR operator used in the above regex is the []. The expression will match for any characters or character classes included in the brackets. For example the [\da-z\.-] expression matches for any digits (\d) OR any characters between a and z (a-z) OR any '.' (\.) OR any '-' (-).  \nFlags: A flag is an optional parameter to a regex that modifies its behavior of searching. A flag changes the default searching behavior of a regular expression. It makes a regex search in a different way. \nIn JavaScript regex, we have a total of 6 flags, each serving a different purpose. \n i -	Ignore Casing-	Makes the expression search case-insensitively. \n        g -	Global-	Makes the expression search for all occurrences. \n s -	Dot All-	Makes the wild character . match newlines as well. \n        m -	Multiline-	Makes the boundary characters ^ and $ match the beginning and ending of every single line instead of the beginning and ending of the whole string. \n        y -	Sticky-	Makes the expression start its searching from the index indicated in its lastIndex property. \n        u -	Unicode-	Makes the expression assume individual characters as code points, not code units, and thus match 32-bit characters as well. \n             Author: Akshata Kumbhar.",
    },
     {
      id: "2",
      img: blog2,
      imgSmall: blog2,
      date: "May 23",
      category: "Web Development",
      title: "Mastering Frontend Development: Essential Skills and Best Practices",
      bg: "#FFF0F8",
      description:
        "Introduction \n Frontend development plays a crucial role in creating immersive and user-friendly web experiences. As the demand for dynamic and responsive websites continues to grow, frontend developers need to stay updated with the latest tools, techniques, and best practices. In this blog post, we'll explore the essential skills every frontend developer should master and provide valuable insights into best practices that will elevate your frontend development game. \n ## Table of Contents \n 1. [Understanding Frontend Development](#understanding-frontend-development) \n 2. [Essential Frontend Development Skills](#essential-frontend-development-skills) \n  - [HTML and CSS Fundamentals](#html-and-css-fundamentals) \n  - [JavaScript Mastery](#javascript-mastery) \n  - [Responsive Design and Mobile Optimization](#responsive-design-and-mobile-optimization) \n- [CSS Preprocessors and Frameworks](#css-preprocessors-and-frameworks)\n   - [Version Control with Git](#version-control-with-git) \n 3. [Frontend Development Best Practices](#frontend-development-best-practices)\n   - [Writing Clean and Maintainable Code](#writing-clean-and-maintainable-code)\n   - [Performance Optimization Techniques](#performance-optimization-techniques)\n   - [Cross-Browser Compatibility](#cross-browser-compatibility)\n   - [Accessibility and Inclusive Design](#accessibility-and-inclusive-design)\n   - [Testing and Debugging](#testing-and-debugging)\n   - [Collaboration and Workflow Efficiency](#collaboration-and-workflow-efficiency) \n 4. [Exploring Frontend Development Tools](#exploring-frontend-development-tools)\n   - [Code Editors and IDEs](#code-editors-and-ides)\n   - [Browser Developer Tools](#browser-developer-tools)\n   - [Build Tools and Task Runners](#build-tools-and-task-runners)\n   - [Frontend Libraries and Frameworks](#frontend-libraries-and-frameworks)\n   - [Design and Prototyping Tools](#design-and-prototyping-tools) \n 5. [Keeping Up with Frontend Trends and Resources](#keeping-up-with-frontend-trends-and-resources)\n   - [Online Communities and Forums](#online-communities-and-forums)\n   - [Blogs and Newsletters](#blogs-and-newsletters)\n   - [Online Courses and Tutorials](#online-courses-and-tutorials)\n   - [Conferences and Events](#conferences-and-events) \n 6. [Conclusion](#conclusion)\n\n\n## Understanding Frontend Development\nIn this section, we'll provide an overview of frontend development and its importance in creating engaging user interfaces. We'll explain the role of HTML, CSS, and JavaScript in frontend development and discuss the relationship between frontend and backend development.\n\n## Essential Frontend Development Skills\nHere, we'll delve into the key skills every frontend developer should possess. We'll cover the fundamentals of HTML and CSS, the power of JavaScript, the importance of responsive design, and the usage of CSS preprocessors and frameworks. We'll also highlight the significance of version control with Git for efficient collaboration.\n- HTML and CSS Fundamentals: We cover the foundational concepts of HTML and CSS, including understanding the structure of HTML documents, using CSS selectors and properties to style web pages, and organizing content with semantic HTML elements.\n\n- JavaScript Mastery: We dive into the power of JavaScript and its role in creating dynamic and interactive web experiences. Topics include working with variables, functions, conditionals, loops, DOM manipulation, and handling events.\n\n- Responsive Design and Mobile Optimization: We discuss the importance of responsive design in creating websites that adapt to different screen sizes and devices. We explore techniques like media queries, flexible layouts, and optimizing images for mobile devices.\n\n- CSS Preprocessors and Frameworks: We introduce CSS preprocessors like Sass or Less, which enhance CSS with variables, mixins, and functions, making stylesheets more maintainable and efficient. Additionally, we discuss popular CSS frameworks like Bootstrap or Tailwind CSS that provide pre-built components and responsive grid systems.\n\n- Version Control with Git: We highlight the significance of version control in collaborative frontend development. We cover the basics of Git, including initializing repositories, creating branches, committing changes, and working with remote repositories.\n\n## Frontend Development Best Practices\nThis section will focus on best practices that enhance the quality and maintainability of frontend code. We'll discuss writing clean and organized code, optimizing performance for faster loading websites, ensuring cross-browser compatibility, implementing accessibility features, and effective testing and debugging techniques. We'll also touch on collaboration strategies and workflow efficiency.\n- Writing Clean and Maintainable Code: We discuss the importance of clean code principles, including proper code formatting, naming conventions, modularization, and documentation. We also touch on the benefits of code linting and code reviews.\n\n- Performance Optimization Techniques: We cover techniques to optimize frontend performance, such as minification and compression of assets, lazy loading of resources, caching, and reducing HTTP requests. We also discuss the impact of performance on user experience and search engine optimization (SEO).\n\n- Cross-Browser Compatibility: We delve into the challenges of ensuring consistent website rendering across different web browsers and provide strategies for testing and handling browser-specific issues. We also discuss the importance of progressive enhancement and graceful degradation.\n\n- Accessibility and Inclusive Design: We emphasize the significance of creating accessible web experiences that cater to users with disabilities. Topics include using semantic HTML, providing alternative text for images, keyboard accessibility, and following Web Content Accessibility Guidelines (WCAG).\n\n- Testing and Debugging: We explore testing methodologies for frontend code, including unit testing, integration testing, and end-to-end testing. We also discuss debugging techniques using browser developer tools and tools like linters and code formatters.\n\n- Collaboration and Workflow Efficiency: We discuss strategies for efficient collaboration in frontend development, including utilizing version control systems, adopting agile methodologies, using project management tools, and establishing effective communication channels.\n\n## Exploring Frontend Development Tools\nHere, we'll introduce a range of essential tools for frontend development. We'll discuss popular code editors and integrated development environments (IDEs), browser developer tools for debugging and inspecting web pages, build tools and task runners for automation, frontend libraries and frameworks for rapid development, and design and prototyping tools for creating intuitive user interfaces.\n- Code Editors and IDEs: We discuss popular code editors and integrated development environments (IDEs) used by frontend developers, such as Visual Studio Code, Sublime Text, or WebStorm. We highlight their features, extensions, and customization options.\n\n- Browser Developer Tools: We explore the built-in developer tools provided by web browsers, such as Chrome DevTools or Firefox Developer Tools. We cover their features, including inspecting and manipulating the DOM, debugging JavaScript, performance profiling, and network analysis.\n\n- Build Tools and Task Runners: We discuss build tools like Webpack or Gulp, which automate\n\ntasks such as bundling and minifying code, optimizing assets, and managing dependencies. We also touch on task runners like Grunt or npm scripts for automating repetitive tasks.\n\n- Frontend Libraries and Frameworks: We provide an overview of popular frontend libraries and frameworks like React, Angular, or Vue.js. We discuss their benefits, use cases, and ecosystem, including state management, component-based architecture, and routing.\n\n- Design and Prototyping Tools: We explore design and prototyping tools like Sketch, Figma, or Adobe XD, which enable frontend developers to create visual designs, wireframes, and interactive prototypes. We discuss the importance of design collaboration and handoff between designers and developers.\n\n## Keeping Up with Frontend Trends and Resources\nFrontend development is a rapidly evolving field, and it's crucial to stay updated with the latest trends and resources. We'll provide insights into online communities, forums, blogs, newsletters, online courses, tutorials, conferences, and events that can help frontend developers expand their knowledge and skills.\n- Online Communities and Forums: We recommend active online communities and forums like Stack Overflow, Reddit, or dev.to, where developers can ask questions, share knowledge, and engage in discussions.\n\n- Blogs and Newsletters: We highlight popular frontend development blogs and newsletters that provide insights, tutorials, and news about the latest trends and technologies. Examples include CSS-Tricks, Smashing Magazine, or A List Apart.\n\n- Online Courses and Tutorials: We suggest online learning platforms like Udemy, Coursera, or freeCodeCamp, where frontend developers can find comprehensive courses and tutorials to enhance their skills and knowledge.\n\n- Conferences and Events: We mention frontend development conferences and events worldwide, both in-person and virtual, that offer opportunities to network with industry experts, attend workshops, and learn about emerging trends.\n\n## Conclusion\nIn the final section, we'll summarize the key points covered in this blog post. We'll emphasize the importance of mastering essential frontend development skills and following best practices to create exceptional user experiences. We'll encourage readers to continuously learn, experiment, and stay up-to-date with the latest trends to excel in frontend development.\n\nBy the end of this blog post, you'll have a solid understanding of the foundational skills required for frontend development and gain insights into best practices and valuable resources. So, let's embark on the journey to become a master frontend developer and create remarkable web experiences!"
     },
    {
      id: "3",
      img: blog3,
      imgSmall: blog3,
      date: "May 23",
      category: "Web Development",
      title: "My Journey: Upskilling and Perseverance in the Face of Challenges",
      bg: "#FEFAF0",
      description:
        "Introduction:\n Embarking on a journey to a new country can be both exciting and daunting. As I left behind my home in India and moved to the United States, I was filled with anticipation for the opportunities that lay ahead. However, the transition wasn't as smooth as I had hoped. In this blog, I will share my five-year journey, starting with the struggle to find a job in the US and how I overcame the challenges by upskilling, focusing on data structures and algorithms, and obtaining a certificate in full stack development from the University of Washington.\n Embracing Change and Upskilling:\n Arriving in the US, I quickly realized that the change in living and professional environment posed significant challenges. Despite my five years of experience with Persistent Systems in India, I found it difficult to secure a job in the US market without local experience. Determined not to be disheartened, I decided to take proactive steps to enhance my skills and increase my chances of success.\n One of the areas I focused on was sharpening my expertise in data structures and algorithms. Understanding their importance in technical interviews, I dedicated countless hours to solving coding challenges on platforms like LeetCode. Through persistent practice and studying various algorithms and data structures, I gradually honed my problem-solving abilities and gained confidence in tackling complex coding problems.\n Full Stack Development Certification:\n Recognizing the need to diversify my skill set and adapt to the evolving demands of the industry, I enrolled in a four-month-long Full Stack Development Certification program offered by the University of Washington. The program covered a wide range of technologies, including HTML, CSS, JavaScript, React, Node.js, SQL, MongoDB, and more.\n During this intensive program, I immersed myself in various projects that provided hands-on experience in developing real-world applications. Some noteworthy projects I worked on included Peas by Spring, a gardening app that aimed to simplify plant care, JATE, a personal IDE for programmers to streamline their coding workflow, and Curate, an art app designed to facilitate art curation and discovery.\n Navigating the Challenges:\n Upon completing the certification program, I began my search for a job in the US. However, the timing was far from ideal, as the market was experiencing a recession and widespread layoffs. Despite the discouraging circumstances, I remained resolute and refused to let the setbacks define me.\n Throughout this challenging period, I focused on keeping my mind stable and calm. Engaging in mindfulness practices, seeking support from peers and mentors, and continuously updating my skills, I stayed motivated and prepared for the opportunities that would arise.\n Mastering the Cloud:\n Recognizing the growing importance of cloud technologies, I extended my skill set by learning about cloud platforms. Azure Cloud became my area of focus, and I delved into understanding its features, services, and deployment options. Through practical projects and experimenting with cloud infrastructure, I gained hands-on experience in leveraging Azure's capabilities.\n Conclusion:\n While my journey in the US has been marked by numerous obstacles, I have refused to give up. Through perseverance, upskilling, and a determination to adapt, I have transformed challenges into opportunities for growth. The Full Stack Development Certification program and the skills I acquired in HTML, CSS, JavaScript, React, Node.js, SQL, MongoDB, and Azure Cloud have equipped me to tackle diverse projects and contribute effectively in the tech industry.\n As I continue my job search, I am confident that my passion, resilience, and ever-expanding skill set will eventually lead me to the right opportunity. My journey is a testament to the power of continuous learning and the unwavering spirit that drives us forward, no matter the obstacles we encounter."
    },
  
     {
      id: "4",
      img: blog4,
      imgSmall: blog4,
      date: "July 23",
      category: "Web Development",
      title: "Streamlining Front-End Testing with Cypress: A Comprehensive Guide",
      bg: "#EEFBFF",
      description:
  "Introduction: As web applications grow in complexity and functionality, ensuring their reliability becomes paramount. Testing plays a crucial role in maintaining the quality and stability of web applications. Among the various testing frameworks available, Cypress has gained significant popularity due to its simplicity, powerful features, and fast execution. In this blog post, we will explore the benefits of Cypress and delve into its key features, along with best practices for efficient front-end testing.\n\nUnderstanding Cypress: - Introduction to Cypress and its purpose in front-end testing - Key differentiators of Cypress compared to other testing frameworks - Cypress architecture and how it works under the hood - Supported browsers and operating systems\n\nGetting Started with Cypress: - Step-by-step guide to setting up Cypress in a new or existing project - Creating test files and organizing test suites - Writing your first Cypress test - Running tests in Cypress Test Runner and understanding the test execution flow\n\nPowerful Features of Cypress: - Automatic waiting and intelligent assertions for robust tests - Real-time reloading and time-travel debugging for faster development - Stubbing and spying on network requests for controlled testing - End-to-end testing with Cypress's ability to interact with APIs and databases\n\nBest Practices for Effective Testing: - Writing reliable and maintainable tests using Cypress best practices - Using page objects for improved test readability and maintenance - Test data management and handling dynamic content - Running tests in different environments and configurations // Sample Cypress test code describe('Login Functionality', () => { it('should successfully log in with valid credentials', () => { // Visit the login page cy.visit('/login'); // Enter username and password cy.get('[data-testid=username]').type('myusername'); cy.get('[data-testid=password]').type('mypassword'); // Click the login button cy.get('[data-testid=login-button]').click(); // Assert the successful login cy.url().should('include', '/dashboard'); cy.get('[data-testid=welcome-message]').should('contain', 'Welcome, myusername!'); }); }); This sample code demonstrates a basic login functionality test using Cypress. It navigates to the login page, enters the username and password, clicks the login button, and then verifies that the user is redirected to the dashboard page and sees a welcome message.\n\nIntegrations and Extensibility: - Integrating Cypress with popular frameworks and tools (e.g., React, Angular, Vue.js) - Leveraging plugins to extend Cypress's capabilities - Incorporating Cypress into continuous integration (CI) pipelines - Generating reports and gathering test metrics\n\nMigrating to Cypress: - Strategies for migrating existing tests to Cypress - Overcoming common challenges during migration - Tips for maximizing the benefits of Cypress in your testing workflows\n\nConclusion: Cypress has emerged as a game-changer in front-end testing, empowering developers and testers to build reliable and efficient web applications. With its user-friendly syntax, powerful features, and extensive community support, Cypress offers an excellent choice for teams seeking to streamline their testing processes. By adopting Cypress and following best practices, you can ensure faster feedback cycles, improved test coverage, and increased confidence in your web application's quality. Start exploring Cypress today and unlock the potential for robust front-end testing."
  },
  
  
  ];

  // Menu items for Homepage One
  const menuItem = [
    {
      id: "01",
      name: "Home",
      link: "/home/homePage",
      icon: <AiOutlineHome />,
    },
    {
      id: "02",
      name: "About",
      link: "home/about",
      icon: <FaRegUser />,
    },
    {
      id: "06",
      name: "Resume",
      link: "/home/resume",
      icon: <CgNotes />,
    },
    {
      id: "03",
      name: "Works",
      link: "/home/works",
      icon: <FiCodesandbox />,
    },
    {
      id: "04",
      name: "Blogs",
      link: "/home/blogs",
      icon: <FaBlogger />,
    },
    {
      id: "05",
      name: "Contact",
      link: "/home/contact",
      icon: <RiContactsBookLine />,
    },
  ];

  // Menu items for Homepage Two
  const menuItemTwo = [
    {
      id: "01",
      name: "About",
      link: "/about",
      icon: <FaRegUser />,
    },
    {
      id: "02",
      name: "Resume",
      link: "/resume",
      icon: <CgNotes />,
    },
    {
      id: "03",
      name: "Works",
      link: "/works",
      icon: <FiCodesandbox />,
    },
    {
      id: "04",
      name: "Blogs",
      link: "/blogs",
      icon: <FaBlogger />,
    },
    {
      id: "05",
      name: "Contact",
      link: "/contact",
      icon: <RiContactsBookLine />,
    },
  ];

  // Slider image for Clients
  const sliderImg = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
  ];

  // experience items for about page
  const experienceArray = [
    {
      id: "1",
      icon: icon,
      title: "App Development",
      des: "Strong knowledge in MERN/MEAN Stack with vast experience in building Web Applications, used React.js for client side, Node.js/Express for server side and MongoDB, SQL Server for database.",
      color: "#D566FF",
      bg: "#FCF4FF",
    },
    {
      id: "2",
      icon: icon1,
      title: "UI Development",
      des: "Extensive knowledge of creating responsive web application using CSS3 media queries, Bootstrap. Expertise in using React.js/Redux to build User Interface, strong knowledge of state store, middleware, action creator, reducer and container.",
      color: "#DDA10C",
      bg: "#FEFAF0",
    },
    {
      id: "3",
      icon: icon5,
      title: "Code Architecture",
      des: "Defined code architecture decisions to support high-performance products. Analyzed business requirement to translate functional requirements into technical requirements and developed web application using MongoDB, Express, React.js and Node.js (MERN stack).",
      color: "#8774FF",
      bg: "#FCF4FF",
    },
    {
      id: "4",
      icon: icon4,
      title: "Back End Devlopement",
      des: "Proficient in creating REST APIs with JavaScript frameworks like Express.js, Node.js as a Middleware and database modelling tool like Mongoose and databases like MongoDB. Used NodeJS and Express framework to build server side logic, and applied with middlewares to handle http requests",
      color: "#FF6080",
      bg: "#FFF4F4",
    },
    {
      id: "5",
      icon: icon3,
      title: "Problem-Solver",
      des: "Team player with excellent communication, Trouble shooting, Debugging and Strong analytical problem solving skills to deliver Technology products and consulting solutions.",
      color: "#FF75D8",
      bg: "#FFF0F8",
    },
    {
      id: "6",
      icon: icon2,
      title: "Interests - Doodling",
      des: "Sketching and drawing is a great way to improve creative skills and start thinking in a different way. I enjoy doodling in my free time.",
      link: "https://www.instagram.com/doodles3011/",
      linktext:"Visit: Instagram-doodles3011",
      color: "#269FFF",
      bg: "#F3FAFF",
    },
  ];

  // Resume items for Resume page
  const resumeArray = [
    {
      type: "Education",
      icon: MdOutlineSchool,
      
      id: "01",
      date: "2012-2016",
      title: "Bachelors of Technology- Computer Science ",
      place: "Rajarambapu Institute of technology, India",
      bg: "#FFF4F4",

      id1: "02",
      date1: "2022",
      title1: "Full Stack Development Certification",
      place1: "University of Washington",
      bg1: "#EEF5FA",

       id2: "03",
      date2: "2023",
      title2: "AZURE AZ-900: MICROSOFT AZURE FUNDAMENTALS CERTIFICATION",
      place2: "Certification",
      bg2: "#EEF5FA",
      
       id3: "04",
      date3: "2022-2023",
      title3: "Freelancing",
      place3: "Upwork Talent",
      bg3: "#EEF5FA",
    
    },

    {
      type: "Experience",
      icon: MdOutlineBusinessCenter,
      
      id: "01",
      date: "Sep 2023 – Present",
      title: "Sr. Consultant- Software Engineer",
      place: "Capgemini America",
      bg: "#F2F4FF",
      
      id1: "02",
      date1: "Jul 2020 – Jun 2020",
      title1: "Module Lead",
      place1: "Persistent Systems",
      bg1: "#FCF4FF",
      
      id2: "03",
      date2: "Sep 2018 – Jun 2020",
      title2: "Sr. Software Engineer",
      place2: "Persistent Systems",
      bg2: "#EEF5FA",

      id3: "04",
      date3: "Nov 2016-Aug 2018",
      title3: "Software Engineer",
      place3: "Persistent Systems",
      bg3: "#F2F4FF",
    }
   /* {
      type: "Awards",
      icon: FaAward,
      id: "02",
      date: "2017",
      title: "Bravo - Team Awards",
      place: "Persitent Systems",
      bg: "#FCF4FF",

      

      id2: "09",
      date2: "2015-2017",
      title2: "Best Freelancer",
      place2: "Fiver & Upwork Level 2 & Top Rated",
      bg2: "#FCF4FF",
    }*/
  ];

  // Working Skills items for Resume page
  const lineArray = [
    {
      id: "01",
      color: "#FF6464",
      name: "Javascript",
      number: "95",
    },
    {
      id: "02",
      color: "#9272D4",
      name: "React ",
      number: "85",
    },
    {
      id: "03",
      color: "#5185D4",
      name: "HTML/CSS",
      number: "80",
    },
    {
      id: "04",
      color: "#CA56F2",
      name: "Java",
      number: "65",
    },
    {
      id: "05",
      color: "#c06c84",
      name: "MongoDB",
      number: "80",
    },
    {
      id: "06",
      color: "#a2c11c",
      name: "MySQL",
      number: "70",
    },
    {
      id: "07",
      color: "#9272D4",
      name: "Node",
      number: "90",
    },
    {
      id: "08",
      color: "#00bbf0",
      name: "Express",
      number: "90",
    },
    {
      id: "09",
      color: "#c06c84",
      name: "jQuery",
      number: "90",
    },
    {
      id: "10",
      color: "#ffcab0",
      name: "Ajax",
      number: "80",
    },
  ];

  // Personal information for contact pages
  const contactArray = [
    {
      id: "01",
      icon: iconPhone,
      title: "Phone ",
      item1: "+1 425 520 5653",
      item2: "+1 425 520 5653",
      bg: "#FCF4FF",
    },
    {
      id: "02",
      icon: iconEmail,
      title: "Email ",
      item1: "akshata.kumbhar@hotmail.com.com",
      item2: "akshata.kumbhar@hotmail.com.com",
      bg: "#EEFBFF",
    },
    {
      id: "03",
      icon: iconMap,
      title: "Address ",
      item1: "Redmond, WA, USA",
      item2: "Redmond, WA, USA",
      bg: "#F2F4FF",
    },
  ];

  return {
    handleTheme,
    check,
    local,
    handleData,
    data,
    singleData,
    handleModelData,
    isOpen,
    setIsOpen,
    blogsData,
    handleBlogsData,
    menuItem,
    NavLink,
    menuItemTwo,
    experienceArray,
    sliderImg,
    resumeArray,
    lineArray,
    contactArray,
  };
};

export default AllData;
